import React from 'react';
import "./StatusTokens.scss";

const StatusToken = ({ label, children, type, onClick }) => {
	return <div onClick={onClick} className={`status-token-outer${type ? " type-" + type : ""}`}><h5>{label || children}</h5></div>;
}

export default StatusToken;